import { Box } from "@mui/material";
import logo from "../assets/eXXI_logo.png";
import image from "../assets/header-image.png";

export default function Header() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "row", md: "row" },
        width: "100%",
      }}
    >
      {/* lewa kolumna na białym tle */}
      <Box
        sx={{
          width: { xs: "100%", md: "25%" }, 
          flexShrink: 0,
          backgroundColor: "#FFFFFF",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          p: 2,
        }}
      >
        <Box
          component="img"
          src={logo}
          alt="Logo exxi"
          sx={{
            width: "100%",
            height: "auto",
            maxWidth: "150px",
            objectFit: "contain",
          }}
        />
      </Box>

      {/* prawa kolumna z obrazkiem */}
      <Box
        sx={{
          flex: "1 1 auto",
          overflow: "hidden",
        }}
      >
        <Box
          component="img"
          src={image}
          alt="background image"
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            display: "block",
          }}
        />
      </Box>
    </Box>
  );
}
